// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"54f8191e","79":"3d47f0db","135":"d881391b","243":"5c34e346","259":"ff59ee6f","288":"87c860d3","426":"70fdf924","511":"f0ff3077","883":"aa395ed3","915":"a991c4fe"}[chunkId] + ".chunk.js";
};